import React, { useState } from "react";
import { formScreenProps, stages } from "./Index";
import { Button, MapComponent, MapInput } from "../../components";
import { toast } from "react-toastify";
import { useCalculator } from "../../hooks";
import { useQuery } from "@tanstack/react-query";

export default function CommuteDistance({
  setCurrentStage,
  onChange,
}: formScreenProps) {
  //go to the next stage
  const handleNextClicked = () => {
    if (commute?.from && commute.to && commute.distance) {
      setCurrentStage(stages.commuteFrequency);
      onChange("commute", {
        from: commute.from.toString(),
        to: commute.to.toString(),
        distance: commute.distance,
      });
    } else {
      toast.warn("Please select locations");
    }
  };

  //go back to the previous stage
  const handleBackClicked = () => {
    setCurrentStage(stages.vehicleSelection);
  };

  const [commute, setCommute] = useState<{
    from?: google.maps.LatLng;
    to?: google.maps.LatLng;
    distance?: string;
  }>();

  const updateFrom = (place: google.maps.LatLng) => {
    setCommute((commute) => ({ ...commute, from: place }));
  };
  const updateDestination = (place: google.maps.LatLng) => {
    setCommute((commute) => ({ ...commute, to: place }));
  };

  const onResponse = (r: google.maps.DirectionsResult) => {
    setCommute((commute) => ({
      ...commute,
      distance: r.routes[0].legs[0].distance?.text,
    }));
  };

  const { getprompt } = useCalculator();

  const { data: text = "" } = useQuery({
    queryKey: ["distance", commute?.distance],
    queryFn: () => getprompt(commute?.distance || ""),
    enabled: !!commute?.distance,
  });

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {/* Form Section */}
      <div className="md:max-w-[70%] justify-center place-self-center">
        <div className="mb-8">
          <p className="font-bold text-2xl mb-3">Commute Distance</p>
          <p>
            Let’s get the details of your commute. Provide your starting point
            and destination to calculate your daily mileage.
          </p>
        </div>
        <div className="flex flex-col gap-6">
          <div>
            <p className="mb-2">Where your journey starts</p>
            <MapInput onSelect={updateFrom} />
          </div>
          <div>
            <p className="mb-2">Where your journey ends</p>
            <MapInput onSelect={updateDestination} />
          </div>
          <div
            className={`${
              commute?.distance
                ? "opacity-100 pointer-events-auto"
                : "opacity-0 pointer-events-none"
            } flex flex-col gap-2 transition-opacity duration-1000 ease-in-out`}
          >
            <p>Your commute (1 way) is approximately:</p>
            <p className="border border-grey rounded-lg p-2 w-fit text-text-grey">
              {commute?.distance}
            </p>
            <p className="italic text-sm">{text}</p>
          </div>
        </div>
        <div className="flex gap-3 mt-6 place-items-center justify-center md:justify-start">
          <Button inverted title="Back" onClick={handleBackClicked} />
          <Button title="Continue" onClick={handleNextClicked} />
        </div>
      </div>

      {/* Image Section */}
      <div className="flex justify-center items-center">
        <MapComponent commute={commute} response={onResponse} />
      </div>
    </div>
  );
}
const fields = {
  country: [],
  make: [],
  model: [],
  year: [],
};
